import ErrorIcon from "@mui/icons-material/Error";
import {
  Chip,
  ChipOwnProps,
  SxProps,
  Tooltip,
  TooltipProps,
  Typography,
} from "@mui/material";

const ErrorChip = ({
  sx,
  size = "medium",
  info,
  icon,
  label,
  color = "error",
  placement = "bottom",
}: {
  sx?: SxProps;
  icon?: JSX.Element;
  size?: ChipOwnProps["size"];
  info?: string | number | null;
  label?: string | JSX.Element;
  color?: ChipOwnProps["color"];
  placement?: TooltipProps["placement"];
}) => (
  <Tooltip
    title={
      <Typography fontSize={11} sx={{ whiteSpace: "pre-line" }}>
        {info}
      </Typography>
    }
    placement={placement}
    sx={sx}
  >
    {label ? (
      <Chip
        size={size}
        color={color}
        label={label}
        icon={icon || <ErrorIcon />}
      />
    ) : (
      icon || <ErrorIcon color="error" />
    )}
  </Tooltip>
);

export default ErrorChip;
